import { Component } from '@angular/core';

@Component({
  selector: 'app-main-client-summary',
  template: ` <router-outlet></router-outlet>`,
})
export class MainClientSummaryComponent {
}
